import * as React from "react";
import { SDKContext } from "./SDKContext";

export function useSDK() {
  return React.useContext(SDKContext);
}
